export const apiURL = {
  // Auth
  // auth: "auth/register",
  signin: "auth/login",
  signUp: "auth/register",
  verifyOtp: "auth/verifyOtp",
  registerBusiness: "/business",
  getBusiness: "/business",
  // forgetPassword: "/forget-password",
  // resetPssword: "/reset-password",

  // service
  createService: "service",
  serviceOwner: "service/owner",
  uploadFile: "file",
  uploadMultiFile: "file/MultifileUpload",
  getServiceOwner: "service/owner",
  updateService: "service/",
  deleteService: "service/",

  // product
  createProduct: "product",
  getProductOwner: "product/owner",
  updateProduct: "product/",
  deleteProduct: "product/",

  // theme
  setNewTheme: "theme",
  getSelectedTheme: "theme",

  getTemplate: "template",
};
